module.exports = __webpack_public_path__ + "static/media/stop-20.d5f4f19e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-20.svg
// module id = 1365
// module chunks = 0